import { EEntityType } from 'shared/api';

export const ENTITY_TYPE_LABEL: Record<EEntityType, string> = {
  [EEntityType.Disease]: 'Disease',
  [EEntityType.DiseasePets]: 'Disease Pets',
  [EEntityType.Vaccine]: 'Vaccine',
  [EEntityType.VaccinePets]: 'Vaccine Pets',
  [EEntityType.Breed]: 'Breed',
};

export const ENTITY_TYPES: EEntityType[] = [
  EEntityType.Disease,
  EEntityType.DiseasePets,
  EEntityType.Vaccine,
  EEntityType.VaccinePets,
  EEntityType.Breed,
];

export const formatPercent = (percent: number): string => `${percent.toFixed(1)}%`;

export const formatCellRatio = (translated: number, total: number): string =>
  `${translated.toLocaleString('en-US')} / ${total.toLocaleString('en-US')}`;

export const percentColorBand = (percent: number): 'success' | 'warning' | 'error' => {
  if (percent > 90) return 'success';
  if (percent > 50) return 'warning';
  return 'error';
};

export const truncate = (text: string, max = 80): string => (text.length > max ? `${text.slice(0, max)}…` : text);
